import React from 'react';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText } from '@facet-wealth/design';
import Disclaimers
  from 'Views/Page/Content/Templates/WizardTemplates/AccountOpeningAgreementTemplate/AccountOpeningAgreementV2Component/Content/Disclaimers/Disclaimers';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import ManagedAccountConsentMessageLayout from './ManagedAccountConsentMessageLayout';


const ManagedAccountDisclaimersMessageMetaOverride = buildFacetDesignOverride()
  .nameOverride('successText', {
    _component: () => FDBodyText,
    _customProps: {
      align: 'center',
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('disclaimers', {
    _component: () => Disclaimers,
  }, overrideReadOnly);


const ManagedAccountDisclaimersMessage = ({ relationship }) => {
  const {
    collection, setCollection, isInitializing, loadingError,
  } = useLink(relationship);

  return (
    <DataContainer
      component={MetaCollectionRenderer}
      componentProps={{
        collection,
        metaOverrideSet: ManagedAccountDisclaimersMessageMetaOverride,
        onSubmit: (resp) => {
          setCollection(resp);
        },
        layout: ManagedAccountConsentMessageLayout,
      }}
      loading={isInitializing}
      loadingError={loadingError}
    />
  );
};

ManagedAccountDisclaimersMessage.propTypes = {
  relationship: PropTypes.object.isRequired,
};
ManagedAccountDisclaimersMessage.defaultProps = {};

export default ManagedAccountDisclaimersMessage;
